<template lang="pug">
  #member-center-settings
    WtTile(ancestor :col="12")
      WtTile(parent vertical :col="12")
        WtTile.members-list-title(
          child
          :col="12"
          :is-loading="!membersLoaded && membersInitialLoadComplete"
        )
          MemberList(
            :member-response-object="adminMembersResponseObject"
            :initial-load-complete="membersInitialLoadComplete"
            @search="onSearch($event)"
            :fetch-action="fetchProgramMembers"
          )

        //- // REMOVED FOR NOW
        //- WtTile(vertical)
          WtTile(parent)
            WtTile(child :col="12")
              MemberCenterAdminInviteNew
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtSwitchQuestionInput from "@@/WtSwitchQuestionInput/WtSwitchQuestionInput";
import MemberList from "@@/MemberCenterAdmin/MemberList";
// import MemberCenterAdminInviteNew from "@@/MemberCenterAdmin/MemberCenterAdminInviteNew";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";

export default {
  name: "MemberCenterSettings",

  components: {
    WtTile,
    MemberList,
    WtTitle,
    WtSwitchQuestionInput
    // MemberCenterAdminInviteNew,
  },

  mixins: [dateUtilityMixin],

  data() {
    return {
      perPage: 5
    };
  },

  computed: {
    ...mapGetters("program", [
      "adminMembersResponseObject",
      "membersLoaded",
      "membersInitialLoadComplete"
    ])
  },

  mounted() {
    this.fetchProgramMembers({});

    this.onSearch = this._.debounce(async query => {
      const response = await this.searchMembers({
        programId: this.$auth.user().programId,
        query: query,
        perPage: this.perPage
      });

      this.setAdminMembersResponseObject(response);
    }, 500);
  },

  methods: {
    ...mapActions("program", [
      "fetchMembers",
      "searchMembers",
      "setAdminMembersResponseObject"
    ]),

    fetchProgramMembers(payload) {
      Object.assign(payload, {
        programId: this.$auth.user().programId,
        perPage: this.perPage
      });

      return this.fetchMembers(payload);
    },

    onSearch() {
      // defining this here, but is overwritten in the
      // mounted call.  Using debounce requires this
      // approach in order for it to work when
      // the component instance is available.
    }
  }
};
</script>

<style lang="sass" scoped>
#member-center
  padding-bottom: 500px

  .members-list-title
    min-height: 300px
</style>
